var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img",style:({
    backgroundImage:
      'url(' + require('../assets/' + _vm.image_name + '.png') + ')',
  }),on:{"click":function($event){return _vm.navigateTo()}}},[(_vm.comToRead > 0)?_c('div',{attrs:{"id":"comToReadBorder"}},[_c('div',{attrs:{"id":"comToRead"}},[_vm._v(_vm._s(_vm.comToRead))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }